"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportDto = void 0;
const canDto_1 = require("./canDto");
const folderDto_1 = require("./folderDto");
class ReportDto {
    constructor(id, title, description, folder, can, contentMetadataId, contentFavoriteId, userId, createdAt, deletedAt, favoriteCount, viewCount, lastViewedAt, popularity, userName) {
        this.id = id;
        this.title = title;
        this.description = description;
        this.folder = folder;
        this.can = can;
        this.contentMetadataId = contentMetadataId;
        this.contentFavoriteId = contentFavoriteId;
        this.userId = userId;
        this.createdAt = createdAt;
        this.deletedAt = deletedAt;
        this.favoriteCount = favoriteCount;
        this.viewCount = viewCount;
        this.lastViewedAt = lastViewedAt;
        this.popularity = popularity;
        this.userName = userName ?? '';
    }
    static get QUERY_FIELDS() {
        return `
        id,title,description,folder(${folderDto_1.FolderDto.QUERY_FIELDS}),content_metadata_id,content_favorite_id,
        user_id,created_at,deleted_at,can(${canDto_1.CanDto.QUERY_FIELDS}),favorite_count`;
    }
}
exports.ReportDto = ReportDto;
